import React from 'react';
import PropTypes from 'prop-types';
import { CSRF_TOKEN } from '../../constants';
import NewMember from './new-member';

class ActivateMemberForm extends React.Component {
  static propTypes = {
    swicus_id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string,
    timezone: PropTypes.string,
    onCancel: PropTypes.func.isRequired
  }

  render() {
    const {
      swicus_id,
      email,
      name,
      timezone,
      onCancel
    } = this.props;

    return (
      <form className="activate-member" action="/account/members/activate" method="POST">
        <input name="authenticity_token" type="hidden" value={CSRF_TOKEN} />
        <input name="user[swicus_id]" type="hidden" value={swicus_id} />
        <input name="user[email]" type="hidden" value={email} />
        <input name="user[name]" type="hidden" value={name} />
        <input name="timezone" type="hidden" value={timezone} />

        <NewMember />

        <p className="submission">
          <button className="mod-primary" name="button" type="submit">Activate Member</button>
          <button onClick={onCancel}>Cancel</button>
        </p>
      </form>
    );
  }
}

export default ActivateMemberForm;